import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutIizenglish from "../views/AboutIizenglish.vue";
import BlogPostsAboutUs from "../views/BlogPostsAboutUs.vue";
import ContactUs from "../views/ContactUs.vue";
import LegalNotices from "../views/LegalNotices.vue";
import TheTeam from "../views/TheTeam.vue";
import TermsOfService from "../views/TermsOfService.vue";
import AppRegistration from "../views/AppRegistration.vue";
import ValidateAccount from "../views/ValidateAccount.vue";
import ChangePassword from "../views/ChangePassword.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import AppSubscription from "../views/AppSubscription.vue";
import PaymentSuccess from "../views/PaymentSuccess.vue";
import PaymentError from "../views/PaymentError.vue";
import GarResourceCas from "../views/GarResourceCas.vue";

const routes = [
  {
    path: "/",
    component: () => import("../layouts/AppLayout.vue"),
    children: [
      {
        path: "/",
        name: "HomePage",
        component: HomePage,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/about",
        name: "AboutIizenglish",
        component: AboutIizenglish,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/blog",
        name: "BlogPostsAboutUs",
        component: BlogPostsAboutUs,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/the-team",
        name: "TheTeam",
        component: TheTeam,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/contact-us",
        name: "ContactUs",
        component: ContactUs,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/legal-notices",
        name: "LegalNotices",
        component: LegalNotices,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/terms-of-service",
        name: "TermsOfService",
        component: TermsOfService,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/login",
        name: "AppLogin",
        component: () =>
          import(/* webpackChunkName: "login" */ "../views/AppLogin.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/two-factor-authentication",
        name: "TwoFactorAuthentication",
        component: () =>
          import(
            /* webpackChunkName: "two-factor-authentication" */ "../views/TwoFactorAuthentication.vue"
          ),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/my-home",
        name: "PersonalHome",
        component: () =>
          import(/* webpackChunkName: "my-home" */ "../views/PersonalHome.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/exercises/menu",
        name: "AdminExerciseMenu",
        component: () =>
          import(
            /* webpackChunkName: "exercises-menu" */ "../views/admin/exercises/AdminExerciseMenu.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/blog/menu",
        name: "AdminBlogMenu",
        component: () =>
          import(
            /* webpackChunkName: "blog-menu" */ "../views/admin/blog/AdminBlogMenu.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/resources",
        name: "AdminResourcesMenu",
        component: () =>
          import(
            /* webpackChunkName: "resources-menu" */ "../views/admin/resources/AdminResources.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/chapters/menu",
        name: "AdminChaptersMenu",
        component: () =>
          import(
            /* webpackChunkName: "exercises-menu" */ "../views/admin/exercises/AdminChaptersMenu.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/students",
        name: "AdminStudentsMenu",
        component: () =>
          import(
            /* webpackChunkName: "admin-students" */ "../views/admin/students/AdminStudentsMenu.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/students/list",
        name: "AdminStudents",
        component: () =>
          import(
            /* webpackChunkName: "admin-students-list" */ "../views/admin/students/AdminStudents.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/blogs/list",
        name: "AdminBlogs",
        component: () =>
          import(
            /* webpackChunkName: "admin-blogs-list" */ "../views/admin/blog/AdminBlogs.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/students/bulk-import",
        name: "AdminStudentsBulkImport",
        component: () =>
          import(
            /* webpackChunkName: "admin-students-bulk-import" */ "../views/admin/students/StudentBulkImport.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/mock-tests",
        name: "AdminMockExamsMenu",
        component: () =>
          import(
            /* webpackChunkName: "admin-mock-exams" */ "../views/admin/mock_exams/AdminMockExamsMenu.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/mock-tests/import",
        name: "AdminMockExamsImport",
        component: () =>
          import(
            /* webpackChunkName: "admin-mock-exams-import" */ "../views/admin/mock_exams/AdminMockExamsImport.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/students/:student_id",
        name: "StudentDetail",
        component: () =>
          import(
            /* webpackChunkName: "student-detail" */ "../views/admin/students/StudentDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/students/creation",
        name: "AdminStudentCreation",
        component: () =>
          import(
            /* webpackChunkName: "admin-student-creation" */ "../views/admin/students/StudentDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/blogs/:blog_id",
        name: "BlogDetail",
        component: () =>
          import(
            /* webpackChunkName: "blog-detail" */ "../views/admin/blog/BlogDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/classes",
        name: "AdminClasses",
        component: () =>
          import(
            /* webpackChunkName: "admin-students" */ "../views/admin/classes/AdminClasses.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/classes/:class_id",
        name: "ClassDetail",
        component: () =>
          import(
            /* webpackChunkName: "admin-class-detail" */ "../views/admin/classes/ClassDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/classes/creation",
        name: "AdminClassCreation",
        component: () =>
          import(
            /* webpackChunkName: "admin-class-detail" */ "../views/admin/classes/ClassDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/schools",
        name: "AdminSchools",
        component: () =>
          import(
            /* webpackChunkName: "admin-schools" */ "../views/admin/schools/AdminSchools.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/school/:school_id",
        name: "SchoolDetail",
        component: () =>
          import(
            /* webpackChunkName: "school-detail" */ "../views/admin/schools/SchoolDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/teachers",
        name: "AdminTeachers",
        component: () =>
          import(
            /* webpackChunkName: "admin-teachers" */ "../views/admin/teachers/AdminTeachers.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/teacher/:teacher_id",
        name: "TeacherDetail",
        component: () =>
          import(
            /* webpackChunkName: "teacher-detail" */ "../views/admin/teachers/TeacherDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/teacher/:teacher_id/homeworks",
        name: "TeacherHomeworks",
        component: () =>
          import(
            /* webpackChunkName: "teacher-homeworks" */ "../views/TeacherHomeworksList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/teachers/creation",
        name: "TeacherCreation",
        component: () =>
          import(
            /* webpackChunkName: "teachers-creation" */ "../views/admin/teachers/TeacherDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/schools/creation",
        name: "SchoolCreation",
        component: () =>
          import(
            /* webpackChunkName: "schools-creation" */ "../views/admin/schools/SchoolDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/countries",
        name: "AdminCountries",
        component: () =>
          import(
            /* webpackChunkName: "admin-countries" */ "../views/admin/countries/AdminCountries.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/countries/:country_id",
        name: "CountryDetail",
        component: () =>
          import(
            /* webpackChunkName: "country-detail" */ "../views/admin/countries/CountryDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/countries/creation",
        name: "CountryCreation",
        component: () =>
          import(
            /* webpackChunkName: "country-creation" */ "../views/admin/countries/CountryDetail.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/tabuleo-subscriptions",
        name: "AdminTabuleoSubscriptions",
        component: () =>
          import(
            /* webpackChunkName: "admin-tabuleo-subscriptions" */ "../views/admin/tabuleo_subscription/AdminTabuleoSubscriptions.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/tabuleo-subscriptions/:school_id",
        name: "TabuleoSubscriptionDetails",
        component: () =>
          import(
            /* webpackChunkName: "admin-tabuleo-subscription-details" */ "../views/admin/tabuleo_subscription/AdminTabuleoSubscriptionDetails.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/gar-subscriptions",
        name: "AdminGarSubscriptions",
        component: () =>
          import(
            /* webpackChunkName: "admin-gar-subscriptions" */ "../views/admin/gar_subscription/AdminGarSubscriptions.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/gar-subscriptions/creation",
        name: "GarSubscriptionCreation",
        component: () =>
          import(
            /* webpackChunkName: "admin-gar-subscription-creation" */ "../views/admin/gar_subscription/AdminGarSubscriptionDetails.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/gar-subscriptions/:subscription_id",
        name: "GarSubscriptionDetails",
        component: () =>
          import(
            /* webpackChunkName: "admin-gar-subscription-details" */ "../views/admin/gar_subscription/AdminGarSubscriptionDetails.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/annual-purge",
        name: "AdminPurge",
        component: () =>
          import(
            /* webpackChunkName: "admin-purge" */ "../views/admin/purge/AdminPurge.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/exercises/creation",
        name: "ExerciseCreation",
        component: () =>
          import(
            /* webpackChunkName: "exercises-creation" */ "../views/admin/exercises/ExerciseCreation.vue"
          ),
      },
      {
        path: "/admin/blog/creation",
        name: "BlogCreation",
        component: () =>
          import(
            /* webpackChunkName: "blog-creation" */ "../views/admin/blog/BlogCreation.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/admin/global-parameters",
        name: "AdminGlobalParameter",
        component: () =>
          import(
            /* webpackChunkName: "global-parameters" */ "../views/admin/global_parameters/AdminGlobalParameter.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/cas",
        name: "GarResourceCas",
        component: GarResourceCas,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/signup",
        name: "SignUp",
        component: AppRegistration,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/validate-account",
        name: "ValidateAccount",
        component: ValidateAccount,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/set-password",
        name: "SetPassword",
        component: () =>
          import(
            /* webpackChunkName: "set-password" */ "../views/SetPassword.vue"
          ),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "/change-password",
        name: "ChangePassword",
        component: ChangePassword,
      },
      {
        path: "/exercises-contents",
        name: "SearchExercises",
        component: () =>
          import(
            /* webpackChunkName: "exercises-contents" */ "../views/SearchExercises.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/student-homeworks",
        name: "StudentHomeworks",
        component: () =>
          import(
            /* webpackChunkName: "student-homeworks" */ "../views/StudentHomeworks.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/exercises/:id",
        name: "ExercisePage",
        component: () =>
          import(
            /* webpackChunkName: "exercise" */ "../views/ExercisePage.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/classes/overview",
        name: "ClassOverview",
        component: () =>
          import(
            /* webpackChunkName: "class-overview" */ "../views/ClassOverview.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/classes/:id",
        name: "TeacherClassEdition",
        component: () =>
          import(
            /* webpackChunkName: "class-edition" */ "../views/ClassEdition.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/classes/creation",
        name: "TeacherClassCreation",
        component: () =>
          import(
            /* webpackChunkName: "class-edition" */ "../views/ClassEdition.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/:pathMatch(.*)*",
        redirect: "/",
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: ForgotPassword,
      },
      {
        path: "/subscribe",
        name: "AppSubscription",
        component: AppSubscription,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payment-success",
        name: "PaymentSuccess",
        component: PaymentSuccess,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/payment-failure",
        name: "PaymentError",
        component: PaymentError,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/homework-creation",
        name: "TeacherHomework",
        component: () =>
          import(
            /* webpackChunkName: "homework-creation" */ "../views/TeacherHomework.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/:id/homework-update/",
        name: "TeacherHomeworkUpdate",
        component: () =>
          import(
            /* webpackChunkName: "homework-creation" */ "../views/TeacherHomework.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/:id/visualize-homework",
        name: "VisualizeHomework",
        component: () =>
          import(
            /* webpackChunkName: "homework-creation" */ "../views/VisualizeHomework.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/:id",
        name: "StudentHomework",
        component: () =>
          import(
            /* webpackChunkName: "homework" */ "../views/StudentHomework.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/teacher-list",
        name: "TeacherHomeworksList",
        component: () =>
          import(
            /* webpackChunkName: "teacher-homeworks-list" */ "../views/TeacherHomeworksList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/mock-tests/list",
        name: "MockExamsList",
        component: () =>
          import(
            /* webpackChunkName: "mock-exams-list" */ "../views/MockExamsList.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/mock-tests/:id/visualize",
        name: "VisualizeMockExam",
        component: () =>
          import(
            /* webpackChunkName: "mock-exam-visualize" */ "../views/VisualizeMockExam.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/mock-tests/:id/assign",
        name: "AssignMockExam",
        component: () =>
          import(
            /* webpackChunkName: "mock-exam-assign-creation" */ "../views/TeacherAssignMockExam.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/homeworks/:id/results",
        name: "StudentHomeworkResults",
        component: () =>
          import(
            /* webpackChunkName: "student-homework-results" */ "../views/StudentHomeworkResults.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/parameters",
        name: "UserParameters",
        component: () =>
          import(
            /* webpackChunkName: "parameters" */ "../views/UserParameters.vue"
          ),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/beneylu",
    component: () =>
      import(
        /* webpackChunkName: "beneyluLayout" */ "../layouts/BeneyluLayout.vue"
      ),
    children: [
      {
        path: "/beneylu/exercises/:id",
        name: "BeneyluExercisePage",
        component: () =>
          import(
            /* webpackChunkName: "beneyluExercise" */ "../views/ExercisePage.vue"
          ),
        props: {
          beneylu: true,
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeResolve((to) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const iizenglishAccessToken = localStorage.getItem(
      "iizenglish-access-token",
    );
    if (iizenglishAccessToken === null) {
      return { path: "/login" };
    } else {
      return true;
    }
  } else {
    return true;
  }
});

export default router;
